import Localize from 'react-intl-universal';

import Link from '@mui/material/Link';
import { useTheme } from '@mui/material/styles';

import { setLanguage } from '@common/Util';

const ContactSupport = () => {
  const theme = useTheme();

  return theme?.footer?.contactSupport ? (
    <Link
      sx={{
        color: theme.footer.color,
        textDecoration: 'none',
        paddingRight: '1rem'
      }}
      href={`mailto:${
        theme?.footer?.contactSupport?.[setLanguage().toLowerCase()] ||
        theme?.footer?.contactSupport?.['en']
      }`}
    >
      {Localize.get('Footer.contactSupport')}
    </Link>
  ) : null;
};

export default ContactSupport;
